import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  overviewNotificationAdapter,
  OverviewNotificationState,
  OVERVIEW_NOTIFICATION_KEY,
} from './overview-notifications.reducer';

const { selectAll } = overviewNotificationAdapter.getSelectors();

const getOverviewNotificationState =
  createFeatureSelector<OverviewNotificationState>(OVERVIEW_NOTIFICATION_KEY);

export const getOverviewNotification = createSelector(
  getOverviewNotificationState,
  (state: OverviewNotificationState) => selectAll(state.notifications),
);

export const areActionsLoaded = createSelector(
  getOverviewNotificationState,
  (state: OverviewNotificationState) => state.loaded,
);
